(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-ready-btht-4390-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ai-ready-product]').forEach(function (section) {
    var title = document.querySelector('.productView-title > span');
    if (title && title.textContent.indexOf('|') !== -1) title.textContent = title.textContent.split('|')[0].trim();
    var offerBadge = document.querySelector('.productView-badge .sale-badge');
    if (offerBadge) {
      function keepOfferLabel() {
        if (offerBadge.textContent.trim() !== 'Pre-order $60.00 Off') offerBadge.textContent = 'Pre-order $60.00 Off';
        offerBadge.classList.add('ai-ready-preorder-offer');
        offerBadge.removeAttribute('aria-hidden');
        offerBadge.setAttribute('aria-label', 'Pre-order $60.00 Off');
      }
      keepOfferLabel();
    }
    var perks = document.querySelector('.shopify-section-group-header-group #perkScroller');
    var officialBenefits = document.querySelector('.productView-details .official-store-benefits');
    var purchaseButtons = document.querySelector('.productView-details .productView-buttons');
    var purchaseItem = purchaseButtons ? purchaseButtons.closest('.productView-moreItem') : null;
    var versionPicker = section.querySelector('[data-ai-ready-version-picker]');
    var price = document.querySelector('.productView-details .productView-price');
    var priceSource = price ? price.closest('.productView-moreItem') : null;
    var purchaseGrid = purchaseButtons ? purchaseButtons.querySelector('.pvGroup-row-new') : null;
    var quantity = purchaseGrid ? purchaseGrid.querySelector('.productView-quantity') : null;
    var purchaseGroup = purchaseGrid ? purchaseGrid.querySelector('.productView-groupTop') : null;
    if (versionPicker && purchaseButtons && price && priceSource && purchaseGrid && quantity && purchaseGroup) {
      var purchaseRow = document.createElement('div');
      purchaseRow.className = 'ai-ready-price-purchase-row';
      purchaseRow.hidden = true;
      purchaseGrid.insertAdjacentElement('beforebegin', purchaseRow);
      var desktopPurchaseLayout = window.matchMedia('(min-width: 750px)');
      function arrangePurchaseLayout() {
        versionPicker.hidden = false;
        if (desktopPurchaseLayout.matches) {
          purchaseRow.append(price, quantity, purchaseGroup);
          purchaseRow.hidden = false;
          priceSource.classList.add('ai-ready-price-source-moved');
          purchaseRow.insertAdjacentElement('afterend', versionPicker);
        } else {
          priceSource.classList.remove('ai-ready-price-source-moved');
          priceSource.appendChild(price);
          purchaseGrid.insertBefore(quantity, purchaseGrid.firstChild);
          quantity.insertAdjacentElement('afterend', purchaseGroup);
          purchaseRow.hidden = true;
          purchaseButtons.insertAdjacentElement('beforebegin', versionPicker);
        }
      }
      arrangePurchaseLayout();
      desktopPurchaseLayout.addEventListener('change', arrangePurchaseLayout);
    } else if (versionPicker && purchaseButtons) {
      versionPicker.hidden = false;
      purchaseButtons.insertAdjacentElement('beforebegin', versionPicker);
    }
    var highlights = section.querySelector('.ai-ready-product__accordion--highlights');
    var heroHighlights = document.querySelector('.ai-ready-hero-highlights');
    if (highlights && purchaseItem && !heroHighlights) {
      highlights.open = true;
      heroHighlights = document.createElement('div');
      heroHighlights.className = 'ai-ready-hero-highlights';
      heroHighlights.appendChild(highlights);
      purchaseItem.insertAdjacentElement('afterend', heroHighlights);
    }
    if (perks && officialBenefits) {
      perks.remove();
      document.body.classList.add('ai-ready-perks-relocated');
    } else if (perks && purchaseItem && !document.querySelector('.ai-ready-purchase-benefits')) {
      var prioritySupport = Array.from(perks.querySelectorAll('.custom-button')).find(function (button) {
        return button.textContent.indexOf('Priority Support Access') !== -1;
      });
      if (prioritySupport) prioritySupport.remove();
      var benefits = document.createElement('aside');
      benefits.className = 'ai-ready-purchase-benefits';
      benefits.setAttribute('aria-label', 'Purchase benefits');
      benefits.appendChild(perks);
      purchaseItem.insertAdjacentElement('afterend', benefits);
      document.body.classList.add('ai-ready-perks-relocated');
    }

    section.querySelectorAll('.ai-ready-product__accordion').forEach(function (details) {
      details.open = true;
    });

    var portalUrl = section.dataset.portalUrl;
    var addonsTarget = section.dataset.addonsTarget;
    var tabOrder = ['details', 'setup', 'reviews', 'addons'];
    var tabLabels = {
      details: 'Product Details',
      setup: 'Setup Guide & Help',
      reviews: 'Q&A/Review',
      addons: 'Add-ons & Accessories'
    };
    function configureTabs(container) {
      if (!container) return;
      var parent = container.querySelector('ul, .ank-mobile-top-tabs-inner');
      if (!parent) return;
      tabOrder.forEach(function (target) {
        var item = container.querySelector('[data-target="' + target + '"]');
        if (!item) return;
        var link = item.matches('a') ? item : item.querySelector('a');
        if (!link) return;
        link.textContent = tabLabels[target];
        if (target === 'setup') {
          link.href = portalUrl;
          link.dataset.fgSupportUrl = portalUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        } else if (target === 'details') {
          link.href = '#ank-desktop-top-tabs-anchor';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'reviews') {
          link.href = '#shopify-product-reviews';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'addons') {
          link.href = addonsTarget;
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
        parent.appendChild(item);
      });
    }
    configureTabs(document.querySelector('#ank-desktop-top-tabs'));
    configureTabs(document.querySelector('#ank-mobile-top-tabs'));
    document.querySelectorAll('#ank-desktop-top-tabs [data-target="setup"] a, #ank-mobile-top-tabs [data-target="setup"]').forEach(function (link) {
      function keepPortalLink() {
        if (link.getAttribute('href') !== portalUrl) link.setAttribute('href', portalUrl);
        if (link.dataset.fgSupportUrl !== portalUrl) link.dataset.fgSupportUrl = portalUrl;
      }
      keepPortalLink();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-ready-btht-4391-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ai-ready-product]').forEach(function (section) {
    var title = document.querySelector('.productView-title > span');
    if (title && title.textContent.indexOf('|') !== -1) title.textContent = title.textContent.split('|')[0].trim();
    var offerBadge = document.querySelector('.productView-badge .sale-badge');
    if (offerBadge) {
      function keepOfferLabel() {
        if (offerBadge.textContent.trim() !== 'Pre-order $60.00 Off') offerBadge.textContent = 'Pre-order $60.00 Off';
        offerBadge.classList.add('ai-ready-preorder-offer');
        offerBadge.removeAttribute('aria-hidden');
        offerBadge.setAttribute('aria-label', 'Pre-order $60.00 Off');
      }
      keepOfferLabel();
    }
    var perks = document.querySelector('.shopify-section-group-header-group #perkScroller');
    var officialBenefits = document.querySelector('.productView-details .official-store-benefits');
    var purchaseButtons = document.querySelector('.productView-details .productView-buttons');
    var purchaseItem = purchaseButtons ? purchaseButtons.closest('.productView-moreItem') : null;
    var versionPicker = section.querySelector('[data-ai-ready-version-picker]');
    var price = document.querySelector('.productView-details .productView-price');
    var priceSource = price ? price.closest('.productView-moreItem') : null;
    var purchaseGrid = purchaseButtons ? purchaseButtons.querySelector('.pvGroup-row-new') : null;
    var quantity = purchaseGrid ? purchaseGrid.querySelector('.productView-quantity') : null;
    var purchaseGroup = purchaseGrid ? purchaseGrid.querySelector('.productView-groupTop') : null;
    if (versionPicker && purchaseButtons && price && priceSource && purchaseGrid && quantity && purchaseGroup) {
      var purchaseRow = document.createElement('div');
      purchaseRow.className = 'ai-ready-price-purchase-row';
      purchaseRow.hidden = true;
      purchaseGrid.insertAdjacentElement('beforebegin', purchaseRow);
      var desktopPurchaseLayout = window.matchMedia('(min-width: 750px)');
      function arrangePurchaseLayout() {
        versionPicker.hidden = false;
        if (desktopPurchaseLayout.matches) {
          purchaseRow.append(price, quantity, purchaseGroup);
          purchaseRow.hidden = false;
          priceSource.classList.add('ai-ready-price-source-moved');
          purchaseRow.insertAdjacentElement('afterend', versionPicker);
        } else {
          priceSource.classList.remove('ai-ready-price-source-moved');
          priceSource.appendChild(price);
          purchaseGrid.insertBefore(quantity, purchaseGrid.firstChild);
          quantity.insertAdjacentElement('afterend', purchaseGroup);
          purchaseRow.hidden = true;
          purchaseButtons.insertAdjacentElement('beforebegin', versionPicker);
        }
      }
      arrangePurchaseLayout();
      desktopPurchaseLayout.addEventListener('change', arrangePurchaseLayout);
    } else if (versionPicker && purchaseButtons) {
      versionPicker.hidden = false;
      purchaseButtons.insertAdjacentElement('beforebegin', versionPicker);
    }
    var highlights = section.querySelector('.ai-ready-product__accordion--highlights');
    var heroHighlights = document.querySelector('.ai-ready-hero-highlights');
    if (highlights && purchaseItem && !heroHighlights) {
      highlights.open = true;
      heroHighlights = document.createElement('div');
      heroHighlights.className = 'ai-ready-hero-highlights';
      heroHighlights.appendChild(highlights);
      purchaseItem.insertAdjacentElement('afterend', heroHighlights);
    }
    if (perks && officialBenefits) {
      perks.remove();
      document.body.classList.add('ai-ready-perks-relocated');
    } else if (perks && purchaseItem && !document.querySelector('.ai-ready-purchase-benefits')) {
      var prioritySupport = Array.from(perks.querySelectorAll('.custom-button')).find(function (button) {
        return button.textContent.indexOf('Priority Support Access') !== -1;
      });
      if (prioritySupport) prioritySupport.remove();
      var benefits = document.createElement('aside');
      benefits.className = 'ai-ready-purchase-benefits';
      benefits.setAttribute('aria-label', 'Purchase benefits');
      benefits.appendChild(perks);
      purchaseItem.insertAdjacentElement('afterend', benefits);
      document.body.classList.add('ai-ready-perks-relocated');
    }

    section.querySelectorAll('.ai-ready-product__accordion').forEach(function (details) {
      details.open = true;
    });

    var portalUrl = section.dataset.portalUrl;
    var addonsTarget = section.dataset.addonsTarget;
    var tabOrder = ['details', 'setup', 'reviews', 'addons'];
    var tabLabels = {
      details: 'Product Details',
      setup: 'Setup Guide & Help',
      reviews: 'Q&A/Review',
      addons: 'Add-ons & Accessories'
    };
    function configureTabs(container) {
      if (!container) return;
      var parent = container.querySelector('ul, .ank-mobile-top-tabs-inner');
      if (!parent) return;
      tabOrder.forEach(function (target) {
        var item = container.querySelector('[data-target="' + target + '"]');
        if (!item) return;
        var link = item.matches('a') ? item : item.querySelector('a');
        if (!link) return;
        link.textContent = tabLabels[target];
        if (target === 'setup') {
          link.href = portalUrl;
          link.dataset.fgSupportUrl = portalUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        } else if (target === 'details') {
          link.href = '#ank-desktop-top-tabs-anchor';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'reviews') {
          link.href = '#shopify-product-reviews';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'addons') {
          link.href = addonsTarget;
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
        parent.appendChild(item);
      });
    }
    configureTabs(document.querySelector('#ank-desktop-top-tabs'));
    configureTabs(document.querySelector('#ank-mobile-top-tabs'));
    document.querySelectorAll('#ank-desktop-top-tabs [data-target="setup"] a, #ank-mobile-top-tabs [data-target="setup"]').forEach(function (link) {
      function keepPortalLink() {
        if (link.getAttribute('href') !== portalUrl) link.setAttribute('href', portalUrl);
        if (link.dataset.fgSupportUrl !== portalUrl) link.dataset.fgSupportUrl = portalUrl;
      }
      keepPortalLink();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-ready-ensemble-pro-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ai-ready-product]').forEach(function (section) {
    if (section.dataset.productHandle !== 'ensemble-pro-wireless-tv-headphones') return;
    var title = document.querySelector('.productView-title > span');
    if (title && title.textContent.indexOf('|') !== -1) title.textContent = title.textContent.split('|')[0].trim();
    var offerLabel = section.dataset.offerLabel.replace(/ /g, "\u00a0");
    var offerBadge = document.querySelector('.productView-badge .sale-badge');
    if (offerBadge) {
      function keepOfferLabel() {
        if (offerBadge.textContent.trim() !== offerLabel) offerBadge.textContent = offerLabel;
        offerBadge.classList.add('ai-ready-preorder-offer');
        offerBadge.removeAttribute('aria-hidden');
        offerBadge.setAttribute('aria-label', offerLabel);
      }
      keepOfferLabel();
    }
    var perks = document.querySelector('.shopify-section-group-header-group #perkScroller');
    var officialBenefits = document.querySelector('.productView-details .official-store-benefits');
    var purchaseButtons = document.querySelector('.productView-details .productView-buttons');
    var purchaseItem = purchaseButtons ? purchaseButtons.closest('.productView-moreItem') : null;
    var versionPicker = section.querySelector('[data-ai-ready-version-picker]');
    var price = document.querySelector('.productView-details .productView-price');
    var priceSource = price ? price.closest('.productView-moreItem') : null;
    var purchaseGrid = purchaseButtons ? purchaseButtons.querySelector('.pvGroup-row-new') : null;
    var quantity = purchaseGrid ? purchaseGrid.querySelector('.productView-quantity') : null;
    var purchaseGroup = purchaseGrid ? purchaseGrid.querySelector('.productView-groupTop') : null;
    if (versionPicker && purchaseButtons && price && priceSource && purchaseGrid && quantity && purchaseGroup) {
      var purchaseRow = document.createElement('div');
      purchaseRow.className = 'ai-ready-price-purchase-row';
      purchaseRow.hidden = true;
      purchaseGrid.insertAdjacentElement('beforebegin', purchaseRow);
      var desktopPurchaseLayout = window.matchMedia('(min-width: 750px)');
      function arrangePurchaseLayout() {
        versionPicker.hidden = false;
        if (desktopPurchaseLayout.matches) {
          purchaseRow.append(price, quantity, purchaseGroup);
          purchaseRow.hidden = false;
          priceSource.classList.add('ai-ready-price-source-moved');
          purchaseRow.insertAdjacentElement('afterend', versionPicker);
        } else {
          priceSource.classList.remove('ai-ready-price-source-moved');
          priceSource.appendChild(price);
          purchaseGrid.insertBefore(quantity, purchaseGrid.firstChild);
          quantity.insertAdjacentElement('afterend', purchaseGroup);
          purchaseRow.hidden = true;
          purchaseButtons.insertAdjacentElement('beforebegin', versionPicker);
        }
      }
      arrangePurchaseLayout();
      desktopPurchaseLayout.addEventListener('change', arrangePurchaseLayout);
    } else if (versionPicker && purchaseButtons) {
      versionPicker.hidden = false;
      purchaseButtons.insertAdjacentElement('beforebegin', versionPicker);
    }
    var highlights = section.querySelector('.ai-ready-product__accordion--highlights');
    var heroHighlights = document.querySelector('.ai-ready-hero-highlights');
    if (highlights && purchaseItem && !heroHighlights) {
      highlights.open = true;
      heroHighlights = document.createElement('div');
      heroHighlights.className = 'ai-ready-hero-highlights';
      heroHighlights.appendChild(highlights);
      purchaseItem.insertAdjacentElement('afterend', heroHighlights);
    }
    if (perks && officialBenefits) {
      perks.remove();
      document.body.classList.add('ai-ready-perks-relocated');
    } else if (perks && purchaseItem && !document.querySelector('.ai-ready-purchase-benefits')) {
      var prioritySupport = Array.from(perks.querySelectorAll('.custom-button')).find(function (button) {
        return button.textContent.indexOf('Priority Support Access') !== -1;
      });
      if (prioritySupport) prioritySupport.remove();
      var benefits = document.createElement('aside');
      benefits.className = 'ai-ready-purchase-benefits';
      benefits.setAttribute('aria-label', 'Purchase benefits');
      benefits.appendChild(perks);
      purchaseItem.insertAdjacentElement('afterend', benefits);
      document.body.classList.add('ai-ready-perks-relocated');
    }

    section.querySelectorAll('.ai-ready-product__accordion').forEach(function (details) {
      details.open = true;
    });

    var askButton = section.querySelector('[data-ai-ready-compatibility-ask]');
    if (askButton) askButton.addEventListener('click', function () {
      var widgetButton = document.querySelector('[data-ask-open]');
      if (widgetButton) widgetButton.click();
    });

    var portalUrl = section.dataset.portalUrl;
    var addonsTarget = section.dataset.addonsTarget;
    var tabOrder = ['details', 'setup', 'reviews', 'addons'];
    var tabLabels = {
      details: 'Product Details',
      setup: 'Setup Guide & Help',
      reviews: 'Q&A/Review',
      addons: 'Add-ons & Accessories'
    };
    function configureTabs(container) {
      if (!container) return;
      var parent = container.querySelector('ul, .ank-mobile-top-tabs-inner');
      if (!parent) return;
      tabOrder.forEach(function (target) {
        var item = container.querySelector('[data-target="' + target + '"]');
        if (!item) return;
        var link = item.matches('a') ? item : item.querySelector('a');
        if (!link) return;
        link.textContent = tabLabels[target];
        if (target === 'setup') {
          link.href = portalUrl;
          link.dataset.fgSupportUrl = portalUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        } else if (target === 'details') {
          link.href = '#ank-desktop-top-tabs-anchor';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'reviews') {
          link.href = '#shopify-product-reviews';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'addons') {
          link.href = addonsTarget;
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
        parent.appendChild(item);
      });
    }
    configureTabs(document.querySelector('#ank-desktop-top-tabs'));
    configureTabs(document.querySelector('#ank-mobile-top-tabs'));
    document.querySelectorAll('#ank-desktop-top-tabs [data-target="setup"] a, #ank-mobile-top-tabs [data-target="setup"]').forEach(function (link) {
      function keepPortalLink() {
        if (link.getAttribute('href') !== portalUrl) link.setAttribute('href', portalUrl);
        if (link.dataset.fgSupportUrl !== portalUrl) link.dataset.fgSupportUrl = portalUrl;
      }
      keepPortalLink();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-ready-product-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ai-ready-product]').forEach(function (section) {
    var supportedHandles = [
      'mediacast-auracast-tv-transmitter-hdmi-arc-in',
      'audikast-4ha-auracast-transmitter-for-hearing-aids',
      'audikast-4-bluetooth-auracast-tv-transmitter-titanium',
      'aura-c-auracast-wireless-usb-c-receiver-for-phone',
      'auraband-auracast-earbuds',
      'auracoil-auracast-personal-receiver',
      'auramic-auracast-microphone-transmitter-for-assistive-listening',
      'fitlock-aura-auracast-earbuds',
      'medley-pebble-2-auracast-tv-earbuds-set',
      'aura-loop-auracast-tv-earbuds-set',
      'opera-aura-wireless-tv-headphones',
      'crescendo-me-tv-wireless-headphones-for-seniors',
      'aura-focus-auracast-tv-earbuds-set',
      'opera-plus-ht6190p-wireless-headphones-for-tv',
      'ht5009p-wireless-tv-headphones',
      'ensemble-ht5150-bluetooth-headphone-for-tv',
      'ht381-wireless-under-chin-earphone-system',
      'shift-wireless-home-entertainment-system',
      'audikast-infinity-nc',
      'audikast-harmony-a2-wireless-tv-speaker',
      'audikast-3-bluetooth-transmitter-for-tv',
      'audikast-4-bluetooth-tv-transmitter',
      'oasis-aura-auracast-transmitter',
      'oasis-plus-2-bluetooth-transmitter-for-tv',
      'orbit-pro-bluetooth-transmitter-for-tv'
    ];
    if (supportedHandles.indexOf(section.dataset.productHandle) === -1) return;

    var title = document.querySelector('.productView-title > span');
    if (title && title.textContent.indexOf('|') !== -1) title.textContent = title.textContent.split('|')[0].trim();

    var offerBadge = document.querySelector('.productView-badge .sale-badge');
    if (offerBadge) {
      var offerAmount = (offerBadge.textContent.match(/[$€£]\s?[\d,.]+/) || [])[0];
      if (offerAmount) {
        var offerLabel = 'Pre-order ' + offerAmount.replace(/\s+/g, '') + ' Off';
        function keepOfferLabel() {
          if (offerBadge.textContent.trim() !== offerLabel) offerBadge.textContent = offerLabel;
          offerBadge.classList.add('ai-ready-preorder-offer');
          offerBadge.removeAttribute('aria-hidden');
          offerBadge.setAttribute('aria-label', offerLabel);
        }
        keepOfferLabel();
      }
    }

    var perks = document.querySelector('.shopify-section-group-header-group #perkScroller');
    var officialBenefits = document.querySelector('.productView-details .official-store-benefits');
    var purchaseButtons = document.querySelector('.productView-details .productView-buttons');
    var purchaseItem = purchaseButtons ? purchaseButtons.closest('.productView-moreItem') : null;
    var price = document.querySelector('.productView-details .productView-price');
    var priceSource = price ? price.closest('.productView-moreItem') : null;
    var purchaseGrid = purchaseButtons ? purchaseButtons.querySelector('.pvGroup-row-new') : null;
    var quantity = purchaseGrid ? purchaseGrid.querySelector('.productView-quantity') : null;
    var purchaseGroup = purchaseGrid ? purchaseGrid.querySelector('.productView-groupTop') : null;
    var productForm = purchaseGrid ? purchaseGrid.closest('form[data-type="add-to-cart-form"]') : null;
    var automaticDiscount = section.dataset.productHandle === 'audikast-4-bluetooth-auracast-tv-transmitter-titanium'
      ? document.querySelector('.productView-details .audikast-discount')
      : null;
    var selectedVariantId = section.dataset.selectedVariantId;

    function restoreSelectedVariantId() {
      var activeProductForm = purchaseButtons
        ? purchaseButtons.querySelector('form[data-type="add-to-cart-form"]') || productForm
        : productForm;
      var variantInput = activeProductForm ? activeProductForm.querySelector('input[name="id"]') : null;
      if (!variantInput || variantInput.value || !selectedVariantId) return;
      variantInput.value = selectedVariantId;
      variantInput.setAttribute('value', selectedVariantId);
    }

    if (purchaseButtons && price && priceSource && purchaseGrid && quantity && purchaseGroup && productForm) {
      var purchaseRow = document.createElement('div');
      purchaseRow.className = 'ai-ready-price-purchase-row';
      purchaseRow.hidden = true;
      purchaseGrid.insertAdjacentElement('beforebegin', purchaseRow);
      var desktopPurchaseLayout = window.matchMedia('(min-width: 750px)');
      function arrangePurchaseLayout() {
        if (desktopPurchaseLayout.matches) {
          purchaseRow.append(price, quantity, purchaseGroup);
          purchaseRow.hidden = false;
          priceSource.classList.add('ai-ready-price-source-moved');
          if (automaticDiscount) purchaseRow.insertAdjacentElement('afterend', automaticDiscount);
        } else {
          priceSource.classList.remove('ai-ready-price-source-moved');
          priceSource.appendChild(price);
          if (automaticDiscount) priceSource.insertAdjacentElement('afterend', automaticDiscount);
          purchaseGrid.insertBefore(quantity, purchaseGrid.firstChild);
          quantity.insertAdjacentElement('afterend', purchaseGroup);
          purchaseRow.hidden = true;
        }
        restoreSelectedVariantId();
      }
      arrangePurchaseLayout();
      desktopPurchaseLayout.addEventListener('change', arrangePurchaseLayout);
      purchaseButtons.addEventListener('submit', restoreSelectedVariantId, true);
      purchaseButtons.addEventListener('click', restoreSelectedVariantId, true);
      new MutationObserver(restoreSelectedVariantId).observe(purchaseButtons, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });
    }

    var highlights = section.querySelector('.ai-ready-product__accordion--highlights');
    var heroHighlights = document.querySelector('.ai-ready-hero-highlights');
    if (highlights && purchaseItem && !heroHighlights) {
      highlights.open = true;
      heroHighlights = document.createElement('div');
      heroHighlights.className = 'ai-ready-hero-highlights';
      heroHighlights.appendChild(highlights);
      purchaseItem.insertAdjacentElement('afterend', heroHighlights);
    }

    if (perks && officialBenefits) {
      perks.remove();
      document.body.classList.add('ai-ready-perks-relocated');
    } else if (perks && purchaseItem && !document.querySelector('.ai-ready-purchase-benefits')) {
      var prioritySupport = Array.from(perks.querySelectorAll('.custom-button')).find(function (button) {
        return button.textContent.indexOf('Priority Support Access') !== -1;
      });
      if (prioritySupport) prioritySupport.remove();
      var benefits = document.createElement('aside');
      benefits.className = 'ai-ready-purchase-benefits';
      benefits.setAttribute('aria-label', 'Purchase benefits');
      benefits.appendChild(perks);
      purchaseItem.insertAdjacentElement('afterend', benefits);
      document.body.classList.add('ai-ready-perks-relocated');
    }

    section.querySelectorAll('.ai-ready-product__accordion').forEach(function (details) {
      details.open = true;
    });

    var portalUrl = section.dataset.portalUrl;
    var addonsTarget = section.dataset.addonsTarget;
    var tabOrder = ['details', 'setup', 'reviews', 'addons'];
    var tabLabels = {
      details: 'Product Details',
      setup: 'Setup Guide & Help',
      reviews: 'Q&A/Review',
      addons: 'Add-ons & Accessories'
    };
    function configureTabs(container) {
      if (!container) return;
      var parent = container.querySelector('ul, .ank-mobile-top-tabs-inner');
      if (!parent) return;
      tabOrder.forEach(function (target) {
        var item = container.querySelector('[data-target="' + target + '"]');
        if (!item) return;
        var link = item.matches('a') ? item : item.querySelector('a');
        if (!link) return;
        link.textContent = tabLabels[target];
        if (target === 'setup') {
          link.href = portalUrl;
          link.dataset.fgSupportUrl = portalUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        } else if (target === 'details') {
          link.href = '#ank-desktop-top-tabs-anchor';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'reviews') {
          link.href = '#shopify-product-reviews';
          link.removeAttribute('target');
          link.removeAttribute('rel');
        } else if (target === 'addons') {
          link.href = addonsTarget;
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
        parent.appendChild(item);
      });
    }
    configureTabs(document.querySelector('#ank-desktop-top-tabs'));
    configureTabs(document.querySelector('#ank-mobile-top-tabs'));
    document.querySelectorAll('#ank-desktop-top-tabs [data-target="setup"] a, #ank-mobile-top-tabs [data-target="setup"]').forEach(function (link) {
      function keepPortalLink() {
        if (link.getAttribute('href') !== portalUrl) link.setAttribute('href', portalUrl);
        if (link.dataset.fgSupportUrl !== portalUrl) link.dataset.fgSupportUrl = portalUrl;
      }
      keepPortalLink();
    });
    document.querySelectorAll('#ank-desktop-top-tabs [data-target="addons"] a, #ank-mobile-top-tabs [data-target="addons"]').forEach(function (link) {
      function keepAddonsLink() {
        if (link.getAttribute('href') !== addonsTarget) link.setAttribute('href', addonsTarget);
      }
      keepAddonsLink();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["all-products-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-all-products-directory]');

    roots.forEach((root) => {
      const catalog = root.querySelector('[data-products-catalog]');
      const grid = root.querySelector('[data-products-grid]');
      const status = root.querySelector('[data-products-status]');
      const buttons = root.querySelectorAll('[data-collection-handle]');
      const cache = new Map();
      const storefrontRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      let activeRequest = 0;

      const imageUrl = (source) => {
        if (!source) return '';

        const url = new URL(source, window.location.origin);
        url.searchParams.set('width', '360');
        return url.toString();
      };

      const productDescription = (product) => {
        const parser = document.createElement('div');
        parser.innerHTML = product.body_html || '';
        const firstBlock = parser.querySelector('p, li, h1, h2, h3, h4, h5, h6');
        const text = (firstBlock?.textContent || parser.textContent || '').replace(/\s+/g, ' ').trim();

        if (!text) return 'See product details for features and compatibility.';

        const firstSentence = text.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim() || text;
        if (firstSentence.length <= 112) return firstSentence;
        return `${firstSentence.slice(0, 109).replace(/\s+\S*$/, '')}…`;
      };

      const renderProducts = (products) => {
        const fragment = document.createDocumentFragment();

        products.forEach((product) => {
          const card = document.createElement('a');
          const imageWrap = document.createElement('span');
          const name = document.createElement('span');
          const description = document.createElement('span');
          const source = product.images?.[0]?.src || product.featured_image || '';

          card.className = 'all-products-directory__product';
          card.href = `${storefrontRoot}products/${encodeURIComponent(product.handle)}`;
          imageWrap.className = 'all-products-directory__product-image';
          name.className = 'all-products-directory__product-name';
          name.textContent = product.title;
          description.className = 'all-products-directory__product-description';
          description.textContent = productDescription(product);

          if (source) {
            const image = document.createElement('img');
            image.className = 'all-products-directory__main-image';
            image.src = imageUrl(source);
            image.alt = product.title;
            image.loading = 'lazy';
            image.width = 360;
            image.height = 360;
            imageWrap.appendChild(image);
          }

          card.append(imageWrap, name, description);
          fragment.appendChild(card);
        });

        grid.replaceChildren(fragment);
      };

      const loadProducts = async (handle) => {
        if (cache.has(handle)) return cache.get(handle);

        const products = [];
        let page = 1;

        while (true) {
          const response = await fetch(`${storefrontRoot}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`);
          if (!response.ok) throw new Error('Unable to load products');
          const data = await response.json();
          const nextProducts = data.products || [];
          products.push(...nextProducts);

          if (nextProducts.length < 250) break;
          page += 1;
        }

        cache.set(handle, products);
        return products;
      };

      const setActiveButton = (activeButton) => {
        buttons.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const productsForButton = async (button) => {
        const handles = [button.dataset.collectionHandle, ...(button.dataset.additionalCollectionHandles || '').split(',')]
          .map((handle) => handle.trim())
          .filter(Boolean);
        const excludedHandles = new Set(
          (button.dataset.excludedProductHandles || '')
            .split(',')
            .map((handle) => handle.trim())
            .filter(Boolean)
        );

        if (!handles.length) return [];

        const productGroups = await Promise.all(handles.map((handle) => loadProducts(handle)));
        const productsByHandle = new Map();

        productGroups.flat().forEach((product) => {
          if (!excludedHandles.has(product.handle) && !productsByHandle.has(product.handle)) {
            productsByHandle.set(product.handle, product);
          }
        });

        return [...productsByHandle.values()];
      };

      const updateButtonCount = async (button) => {
        const count = button.querySelector('[data-category-count]');
        if (!count) return;

        const products = await productsForButton(button);
        count.textContent = products.length;
      };

      const loadCollection = async (button) => {
        const label = button.dataset.categoryLabel;
        const requestId = ++activeRequest;

        setActiveButton(button);
        catalog.setAttribute('aria-busy', 'true');
        status.textContent = `Loading ${label}…`;

        try {
          const products = await productsForButton(button);
          if (requestId !== activeRequest) return;

          renderProducts(products);
          const count = button.querySelector('[data-category-count]');
          if (count) count.textContent = products.length;
          status.textContent = `${products.length} ${products.length === 1 ? 'product' : 'products'}`;
        } catch (error) {
          if (requestId === activeRequest) {
            status.textContent = 'Products could not be loaded. Please try again.';
          }
        } finally {
          if (requestId === activeRequest) catalog.setAttribute('aria-busy', 'false');
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => loadCollection(button));
      });

      const initialButton = root.querySelector('[data-collection-handle].is-active') || buttons[0];
      if (initialButton) {
        loadCollection(initialButton).then(() => {
          buttons.forEach((button) => {
            if (button !== initialButton) updateButtonCount(button).catch(() => {});
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-c-phone-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-aurac-add]');
      if (!button || button.disabled) return;
      const section = button.closest('[data-aurac-kit]');
      const status = section.querySelector('[data-aurac-status]');
      const defaultLabel = button.textContent.trim();
      button.disabled = true;
      button.textContent = 'Adding…';
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
        window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item.';
        button.disabled = false;
        button.textContent = defaultLabel;
        button.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-shipping-reference"]) return;
  try {
    
(function(){
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-avsr-search]');
    const rows = Array.from(root.querySelectorAll('[data-avsr-row]'));
    const count = root.querySelector('[data-avsr-count]');
    const heading = root.querySelector('[data-avsr-results-heading]');
    const empty = root.querySelector('[data-avsr-empty]');
    const clear = root.querySelector('[data-avsr-clear]');
    const quick = Array.from(root.querySelectorAll('[data-avsr-quick]'));
    const normalize = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
    const entries = rows.map(row => ({row, code:normalize(row.dataset.code), name:normalize(row.dataset.search)}));
    const filter = () => {
      const query = normalize(input.value);
      const exactCode = query.length === 2 && entries.some(entry => entry.code === query);
      let found = 0;
      entries.forEach(entry => {
        const show = !query || (exactCode ? entry.code === query : query.split(' ').every(part => entry.name.includes(part)));
        entry.row.hidden = !show;
        if (show) found++;
      });
      heading.textContent = query ? heading.dataset.searchTitle : heading.dataset.allTitle;
      count.textContent = root.dataset.countTemplate.replace('__COUNT__',String(found));
      empty.hidden = found !== 0;
      clear.hidden = input.value.length === 0;
      quick.forEach(button => button.setAttribute('aria-pressed',String(query === normalize(button.dataset.avsrQuick))));
    };
    const reset = () => { input.value=''; filter(); input.focus(); };
    input.addEventListener('input',filter);
    input.addEventListener('keydown',event => { if(event.key==='Escape'){ event.preventDefault(); reset(); } });
    clear.addEventListener('click',reset);
    root.querySelector('[data-avsr-reset]').addEventListener('click',reset);
    quick.forEach(button => button.addEventListener('click',() => {input.value=button.dataset.avsrQuick;filter();}));
    filter();
  };
  document.querySelectorAll('[data-avsr]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-avsr]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avantree-shipping-policy"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-av-shipping-policy]');
  if (root) {
    const groups = [
      { origin:'United States', type:'local', min:2, max:5, countries:'US' },
      { origin:'Canada', type:'local', min:3, max:5, countries:'CA' },
      { origin:'United Kingdom', type:'local', min:3, max:5, countries:'GB' },
      { origin:'Europe', type:'local', min:3, max:5, countries:'DE,ES,FR,IT' },
      { origin:'Europe', type:'local', min:5, max:10, countries:'AT,BE,BG,CZ,DK,EE,FI,GR,HU,IE,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,SE,CY,HR' },
      { origin:'Australia', type:'local', min:3, max:7, countries:'AU' },
      { origin:'China', type:'international', min:7, max:13, countries:'JP,SG,NZ,CH' },
      { origin:'China', type:'international', min:8, max:13, countries:'AU' },
      { origin:'China', type:'international', min:7, max:12, countries:'CA,AT,BE,BG,CY,CZ,DE,DK,EE,ES,FI,FR,GB,GR,HR,HU,IE,IT,LT,LU,LV,MT,NL,PL,PT,RO,SE,SI,SK' },
      { origin:'China', type:'international', min:10, max:20, countries:'NO' }
    ];
    const continentGroups = [
      { code:'AF', countries:'AO,BF,BI,BJ,BW,CD,CF,CG,CI,CM,CV,DJ,DZ,EG,EH,ER,ET,GA,GH,GM,GN,GQ,GW,IO,KE,KM,LR,LS,LY,MA,MG,ML,MR,MU,MW,MZ,NA,NE,NG,RE,RW,SC,SD,SH,SL,SN,SO,SS,ST,SZ,TD,TF,TG,TN,TZ,UG,YT,ZA,ZM,ZW' },
      { code:'AS', countries:'AE,AF,AM,AZ,BD,BH,BN,BT,CN,CY,GE,HK,ID,IL,IN,IQ,JO,JP,KG,KH,KR,KW,KZ,LA,LB,LK,MM,MN,MO,MV,MY,NP,OM,PH,PK,PS,QA,SA,SG,TH,TJ,TL,TM,TR,TW,UZ,VN,YE' },
      { code:'EU', countries:'AD,AL,AT,AX,BA,BE,BG,BY,CH,CZ,DE,DK,EE,ES,FI,FO,FR,GB,GG,GI,GR,HR,HU,IE,IM,IS,IT,JE,LI,LT,LU,LV,MC,MD,ME,MK,MT,NL,NO,PL,PT,RO,RS,RU,SE,SI,SJ,SK,SM,UA,VA,XK' },
      { code:'NA', countries:'AG,AI,AW,BB,BL,BM,BQ,BS,BZ,CA,CR,CW,DM,DO,GD,GL,GP,GT,HN,HT,JM,KN,KY,LC,MF,MQ,MS,MX,NI,PA,PM,SV,SX,TC,TT,US,VC,VG' },
      { code:'SA', countries:'AR,BO,BR,CL,CO,EC,FK,GF,GS,GY,PE,PY,SR,UY,VE' },
      { code:'OC', countries:'AU,CC,CK,CX,FJ,KI,NC,NF,NR,NU,NZ,PF,PG,PN,SB,TK,TO,TV,UM,VU,WF,WS' },
      { code:'OT', countries:'AC,TA' }
    ];
    const names = new Intl.DisplayNames(['en'], { type:'region' });
    const countryName = code => ({ US:'United States', GB:'United Kingdom', HK:'Hong Kong SAR', MO:'Macao SAR', TW:'Taiwan' }[code] || names.of(code) || code);
    const routes = new Map();
    for (const group of groups) {
      for (const code of group.countries.split(',')) {
        if (!routes.has(code)) routes.set(code, []);
        routes.get(code).push(group);
      }
    }
    const continent = root.querySelector('[data-av-continent]');
    const combo = root.querySelector('[data-av-combobox]');
    const countryInput = root.querySelector('[data-av-country]');
    const toggle = root.querySelector('[data-av-toggle]');
    const options = root.querySelector('[data-av-options]');
    const searchInput = root.querySelector('[data-av-search]');
    const optionList = root.querySelector('[data-av-option-list]');
    const empty = root.querySelector('[data-av-empty]');
    const status = root.querySelector('[data-av-status]');
    const estimate = root.querySelector('[data-av-estimate]');
    const routeText = root.querySelector('[data-av-route]');
    const fallbackText = root.querySelector('[data-av-fallback]');
    const scope = root.querySelector('[data-av-scope]');
    const microcopy = root.querySelector('[data-av-microcopy]');
    const initialResult = { status:status.textContent, estimate:estimate.textContent, route:routeText.textContent };
    const byContinent = new Map(continentGroups.map(group => [group.code, group.countries.split(',')]));
    let selectedCountry = '';
    const closeOptions = () => { options.hidden = true; countryInput.setAttribute('aria-expanded', 'false'); };
    function chooseCountry(code, focusSelected = false) {
      selectedCountry = code;
      countryInput.value = code === 'OTHER' ? root.dataset.unlistedOption : countryName(code);
      closeOptions();
      render();
      if (focusSelected) countryInput.focus();
    }
    function renderOptions() {
      optionList.querySelectorAll('button').forEach(button => button.remove());
      const search = searchInput.value.trim().toLocaleLowerCase();
      const matches = (byContinent.get(continent.value) || []).filter(code => countryName(code).toLocaleLowerCase().includes(search)).sort((a,b) => countryName(a).localeCompare(countryName(b)));
      empty.hidden = matches.length > 0;
      for (const code of [...matches, 'OTHER']) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('role', 'option');
        button.dataset.code = code;
        button.textContent = code === 'OTHER' ? root.dataset.unlistedOption : countryName(code);
        button.addEventListener('click', () => chooseCountry(code, true));
        optionList.appendChild(button);
      }
    }
    function showOptions() {
      if (!continent.value) return;
      searchInput.value = '';
      renderOptions();
      options.hidden = false;
      countryInput.setAttribute('aria-expanded', 'true');
      searchInput.focus();
    }
    const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll('{' + key + '}', value), template);
    const range = method => format(root.dataset.range, { min:method.min, max:method.max });
    function renderUnavailable(code) {
      status.textContent = code === 'OTHER' ? root.dataset.unlistedStatus : format(root.dataset.routeStatus, { country:countryName(code) });
      estimate.textContent = root.dataset.unavailableEstimate;
      const contactLink = document.createElement('a');
      contactLink.href = root.dataset.unavailableContactUrl;
      contactLink.textContent = root.dataset.unavailableContactLabel;
      routeText.replaceChildren(root.dataset.unavailableDetail + ' ', contactLink, root.dataset.unavailableContactSuffix);
      fallbackText.hidden = true;
      scope.hidden = true;
    }
    function render() {
      const code = selectedCountry;
      microcopy.hidden = Boolean(code) && !routes.has(code);
      if (!code) {
        status.textContent = initialResult.status;
        estimate.textContent = initialResult.estimate;
        routeText.textContent = initialResult.route;
        fallbackText.hidden = true;
        scope.hidden = true;
        return;
      }
      if (code === 'OTHER' || !routes.has(code)) {
        renderUnavailable(code);
        return;
      }
      const list = routes.get(code) || [];
      const local = list.find(method => method.type === 'local' && method.origin !== 'China');
      const primary = local || list.reduce((best, method) => !best || method.max < best.max ? method : best, null);
      const fallback = local && list.find(method => method.origin === 'China');
      status.textContent = format(root.dataset.routeStatus, { country:countryName(code) });
      estimate.textContent = range(primary);
      const publicOrigin = primary.origin === 'China' ? root.dataset[primary.type === 'local' ? 'regionalWarehouse' : 'internationalWarehouse'] : primary.origin;
      routeText.textContent = format(root.dataset[primary.type === 'local' ? 'localRoute' : 'internationalRoute'], { origin:publicOrigin });
      fallbackText.hidden = !fallback;
      if (fallback) {
        const [before, after = ''] = root.dataset.fallback.split('{range}');
        const emphasis = document.createElement('strong');
        emphasis.textContent = range(fallback);
        fallbackText.replaceChildren(before, emphasis, after);
      }
      scope.hidden = false;
    }
    continent.addEventListener('change', () => {
      selectedCountry = '';
      countryInput.value = '';
      searchInput.value = '';
      countryInput.disabled = !continent.value;
      toggle.disabled = !continent.value;
      closeOptions();
      render();
    });
    countryInput.addEventListener('click', () => { if (options.hidden) showOptions(); else closeOptions(); });
    countryInput.addEventListener('keydown', event => {
      if (['ArrowDown', 'Enter', ' '].includes(event.key)) { event.preventDefault(); showOptions(); }
      if (event.key === 'Escape') closeOptions();
    });
    searchInput.addEventListener('input', renderOptions);
    searchInput.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); optionList.querySelector('button')?.focus(); }
      if (event.key === 'Enter') { event.preventDefault(); optionList.querySelector('button')?.click(); }
      if (event.key === 'Escape') { event.preventDefault(); closeOptions(); countryInput.focus(); }
    });
    toggle.addEventListener('click', () => {
      if (options.hidden) showOptions(); else { closeOptions(); countryInput.focus(); }
    });
    optionList.addEventListener('keydown', event => {
      const buttons = [...optionList.querySelectorAll('button')];
      const index = buttons.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); buttons[Math.min(index + 1, buttons.length - 1)]?.focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); (index <= 0 ? searchInput : buttons[index - 1])?.focus(); }
      if (event.key === 'Escape') { event.preventDefault(); closeOptions(); countryInput.focus(); }
    });
    combo.addEventListener('focusout', () => setTimeout(() => { if (!combo.contains(document.activeElement)) closeOptions(); }, 0));
    document.addEventListener('pointerdown', event => { if (!combo.contains(event.target)) closeOptions(); });
    const defaultCountry = root.dataset.defaultCountry;
    const defaultContinent = continentGroups.find(group => group.countries.split(',').includes(defaultCountry));
    if (defaultContinent) {
      continent.value = defaultContinent.code;
      countryInput.disabled = false;
      toggle.disabled = false;
      chooseCountry(defaultCountry);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harmony5318-kit"] && !Shopify.designMode) return;
  try {
    
(()=>{document.addEventListener('click',async event=>{const button=event.target.closest('[data-harmony5318-add]');if(!button||button.disabled)return;const section=button.closest('[data-harmony5318-kit]');const status=section.querySelector('[data-harmony5318-status]');const defaultLabel=button.textContent.trim();button.disabled=true;button.textContent='Adding…';button.setAttribute('aria-busy','true');status.textContent='';try{const response=await fetch(button.dataset.addUrl,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item.');window.location.assign(button.dataset.cartUrl)}catch(error){status.textContent=error.message||'Unable to add this item.';button.disabled=false;button.textContent=defaultLabel;button.removeAttribute('aria-busy')}})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

         if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinity-nc-couple-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const refreshCartDrawer = async (cartUrl) => {
      const cartResponse = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('cart_refresh_failed');
      const cart = await cartResponse.json();

      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = cart.item_count;
      });

      const drawer = document.getElementById('halo-cart-sidebar');
      const drawerContent = drawer?.querySelector('.previewCart-wrapper');
      if (!drawer || !drawerContent || !window.quick_cart?.show) return false;

      const drawerResponse = await fetch(`${cartUrl}?view=ajax_side_cart`, { headers: { Accept: 'text/html' } });
      if (!drawerResponse.ok) throw new Error('drawer_refresh_failed');
      drawerContent.innerHTML = await drawerResponse.text();
      document.body.classList.add('cart-sidebar-show');
      return true;
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-kit-add]');
      if (!button || button.disabled) return;

      const section = button.closest('[data-couple-kit]');
      const buttons = section.querySelectorAll('[data-kit-add]');
      const statuses = section.querySelectorAll('[data-kit-status]');
      const defaultLabel = button.dataset.labelDefault;

      buttons.forEach((item) => {
        item.disabled = true;
        item.textContent = button.dataset.labelLoading;
        item.setAttribute('aria-busy', 'true');
      });
      statuses.forEach((status) => { status.textContent = ''; });

      try {
        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              { id: Number(button.dataset.bundleId), quantity: 1 }
            ]
          })
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || button.dataset.errorMessage);

        buttons.forEach((item) => { item.textContent = button.dataset.labelSuccess; });
        let drawerOpened = false;
        try {
          drawerOpened = await refreshCartDrawer(button.dataset.cartUrl);
        } catch (drawerError) {
          drawerOpened = false;
        }
        if (!drawerOpened) window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        statuses.forEach((status) => { status.textContent = error.message || button.dataset.errorMessage; });
        buttons.forEach((item) => {
          item.disabled = false;
          item.textContent = defaultLabel;
          item.removeAttribute('aria-busy');
        });
        return;
      }

      buttons.forEach((item) => {
        item.disabled = false;
        item.removeAttribute('aria-busy');
      });
      window.setTimeout(() => {
        buttons.forEach((item) => { item.textContent = defaultLabel; });
      }, 1800);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasis-aura-aura-c-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getCart = () => new Promise((resolve, reject) => {
      if (!window.Shopify?.getCart) {
        reject(new Error('cart_api_unavailable'));
        return;
      }
      window.Shopify.getCart(resolve);
    });

    const refreshCart = async (cartUrl) => {
      if (window.halo?.updateSidebarCart && window.Shopify?.getCart) {
        const cart = await getCart();
        window.halo.updateSidebarCart(cart);
        document.querySelectorAll('[data-cart-count]').forEach((element) => {
          element.textContent = cart.item_count;
        });
        document.body.classList.add('cart-sidebar-show');
        return;
      }
      window.location.assign(cartUrl);
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-kit-add]');
      if (!button || button.disabled) return;

      const section = button.closest('[data-venue-kit]');
      const status = section.querySelector('[data-kit-status]');
      const defaultLabel = button.dataset.labelDefault;

      button.disabled = true;
      button.textContent = button.dataset.labelLoading;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';

      try {
        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              { id: Number(button.dataset.bundleId), quantity: 1 }
            ]
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || button.dataset.errorMessage);

        button.textContent = button.dataset.labelSuccess;
        await refreshCart(button.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || button.dataset.errorMessage;
        button.disabled = false;
        button.textContent = defaultLabel;
        button.removeAttribute('aria-busy');
        return;
      }

      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.setTimeout(() => { button.textContent = defaultLabel; }, 1800);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["open-ear-tv-listening"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',async(e)=>{const b=e.target.closest('[data-add-to-cart]');if(!b||b.disabled)return;const s=b.closest('[data-open-ear-tv-listening]').querySelector('[data-cart-status]');b.disabled=true;b.textContent='Adding…';try{const r=await fetch(b.dataset.addUrl,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(b.dataset.variantId),quantity:1}]})});if(!r.ok){const j=await r.json();throw new Error(j.description||'Unable to add this item.')}window.location.assign(b.dataset.cartUrl)}catch(err){s.textContent=err.message;b.disabled=false;b.textContent='Add to Cart'}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["replacement-claim-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-replacement-claim]').forEach(function (root) {
    var copyNode = root.querySelector('[data-replacement-claim-copy]');
    var copy = copyNode ? JSON.parse(copyNode.textContent) : {};
    var agentField = root.querySelector('.replacement-claim__agent-field');
    var otherModel = root.querySelector('.replacement-claim__other-model');
    var otherModelInput = root.querySelector('#ReplacementClaimOtherModel');
    var productNote = root.querySelector('[data-product-note]');
    var productNoteTitle = root.querySelector('[data-product-note-title]');
    var productNoteCopy = root.querySelector('[data-product-note-copy]');
    var timing = root.querySelector('.replacement-claim__timing');
    var timingSelect = root.querySelector('#ReplacementClaimTiming');
    var movement = root.querySelector('.replacement-claim__movement');
    var symptomSummary = root.querySelector('[data-symptom-summary]');
    var routingHint = root.querySelector('[data-routing-hint]');
    var symptomError = root.querySelector('.replacement-claim__symptom-error');
    var form = root.querySelector('form');

    root.querySelectorAll('[data-mode]').forEach(function (input) {
      input.addEventListener('change', function () {
        agentField.hidden = input.value !== 'Support agent';
      });
    });

    root.querySelectorAll('[data-product]').forEach(function (input) {
      input.addEventListener('change', function () {
        otherModel.hidden = input.value !== 'Other model';
        otherModelInput.required = input.value === 'Other model';
        if (input.value === 'C171') {
          productNote.hidden = false;
          productNoteTitle.textContent = copy.c171Title;
          productNoteCopy.textContent = copy.c171Copy;
        } else if (input.value === 'E171') {
          productNote.hidden = false;
          productNoteTitle.textContent = copy.e171Title;
          productNoteCopy.textContent = copy.e171Copy;
        } else {
          productNote.hidden = true;
        }
      });
    });

    root.querySelectorAll('[data-worked]').forEach(function (input) {
      input.addEventListener('change', function () {
        timing.hidden = input.dataset.worked !== 'yes';
        timingSelect.required = input.dataset.worked === 'yes';
      });
    });

    function updateSymptoms() {
      var checked = Array.from(root.querySelectorAll('[data-symptom]:checked'));
      symptomSummary.value = checked.map(function (input) { return input.value; }).join(', ');
      movement.hidden = !root.querySelector('[data-intermittent]:checked');
      symptomError.hidden = checked.length > 0;
      var worked = root.querySelector('[data-worked]:checked');
      var timingValue = timingSelect.value;
      if (worked && worked.dataset.worked === 'never' && checked.some(function (input) {
        return input.value === 'No sound' || input.value === 'Device does not recognize the earbuds';
      })) {
        routingHint.value = 'Compatibility / setup check';
      } else if (worked && worked.dataset.worked === 'yes' && ['After a few weeks', 'After a few months', 'After 1 year or more'].indexOf(timingValue) > -1) {
        routingHint.value = 'Possible in-use product failure';
      } else if (root.querySelector('[data-intermittent]:checked')) {
        routingHint.value = 'Intermittent connection check';
      } else {
        routingHint.value = 'Technical review needed';
      }
    }

    root.querySelectorAll('[data-symptom], [data-worked], #ReplacementClaimTiming').forEach(function (input) {
      input.addEventListener('change', updateSymptoms);
    });

    form.addEventListener('submit', function (event) {
      updateSymptoms();
      if (!symptomSummary.value) {
        event.preventDefault();
        symptomError.hidden = false;
        root.querySelector('.replacement-claim__symptoms').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc480ha-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-tc480ha-add]');
      if (!button || button.disabled) return;
      const section = button.closest('[data-tc480ha-kit]');
      const status = section.querySelector('[data-tc480ha-status]');
      const defaultLabel = button.textContent.trim();
      button.disabled = true;
      button.textContent = 'Adding…';
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
        window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item.';
        button.disabled = false;
        button.textContent = defaultLabel;
        button.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-new-solutions"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-whats-new-feedback]').forEach((feedback) => {
    const form = feedback.querySelector('[data-feedback-form]');
    const voteButtons = feedback.querySelectorAll('[data-feedback-vote]');
    const message = feedback.querySelector('[data-feedback-message]');
    const count = feedback.querySelector('[data-feedback-count]');
    const submit = feedback.querySelector('[data-feedback-submit]');
    const status = feedback.querySelector('[data-feedback-status]');
    let selectedVote = '';

    voteButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedVote = button.dataset.feedbackVote;
        voteButtons.forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        submit.disabled = false;
        status.textContent = '';
      });
    });

    message.addEventListener('input', () => {
      count.textContent = `${message.value.length} / 500`;
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!selectedVote || !form.reportValidity()) return;

      submit.disabled = true;
      submit.textContent = 'Sending…';
      status.textContent = '';

      const formData = new FormData();
      const reasons = Array.from(form.querySelectorAll('input[name="reason"]:checked')).map((input) => input.value);
      const email = form.querySelector('input[name="email"]').value.trim();
      formData.set('subject', "What's New Page Feedback");
      formData.set('vote', selectedVote === 'yes' ? 'Yes' : 'Not yet');
      formData.set('reasons', reasons.join(', '));
      formData.set('message', message.value.trim());
      formData.set('page_title', document.title);
      formData.set('page_url', window.location.href.split('#')[0]);
      formData.set('page_path', window.location.pathname);
      formData.set('form_version', 'whats-new-feedback-v1');
      formData.set('submitted_at', new Date().toISOString());
      formData.set('_gotcha', form.querySelector('input[name="_gotcha"]').value);
      if (email) formData.set('email', email);

      try {
        const response = await fetch('https://formspree.io/f/mjknlvvp', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error('Feedback submission failed');

        form.reset();
        selectedVote = '';
        message.dispatchEvent(new Event('input'));
        voteButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
        status.textContent = 'Thank you — your feedback was sent.';
      } catch (error) {
        status.textContent = 'We couldn’t send your feedback. Please try again.';
      } finally {
        submit.textContent = 'Send feedback';
        submit.disabled = !selectedVote;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
